module.exports = __webpack_public_path__ + "img/group@2x.1c2fe8d7.png";